<template>
  <div>
    <v-toolbar flat dense class="mb-4">
      <v-toolbar-title>{{ $t(`headings.${$route.name}`) }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
    </v-toolbar>
    <v-container>
      <v-row>
        <v-col cols="12" class="mx-auto">
          <locale-select @change="fireLocaleChange" />
        </v-col>

        <v-col cols="12">
          <component
            :mediaPhotos="media_photos"
            :mediaVideos="media_videos"
            :filesData="filesData"
            :booleanObject="booleanObject"
            :form="form"
            :locale="locale"
            :is="component"
            @update_medila_files="OnUpdateMediaFiles"
          ></component>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { IndexData } from "@/helpers/apiMethods";

export default {
  name: "Pages",
  components: {
    media_center: () => import("./media-center"),
    identity: () => import("./identity"),
    informations: () => import("./informations")
  },
  data() {
    return {
      component: "",
      locale: this.locale,
      form: {},
      booleanObject: {},
      filesData: {},
      media_photos: [],
      media_videos: []
    };
  },

  methods: {
    OnUpdateMediaFiles(fileName, files) {
      this[fileName] = files;
    },
    fireLocaleChange(locale) {
   
      this.locale = locale;
      this.getPageSettings();
    },
    async getPageSettings(locale = this.locale) {
      const res = await IndexData({
        reqName: "page-settings",
        query: { page_name: this.$route.name },
        locale
      });
      const { data } = res.data;
      for (const key of data) {
        if (typeof key.value !== "boolean" && typeof key.value !== "object") {
          this.form[key.type] = key.value;
          this.form = { ...this.form };
        } else if (typeof key.value == "boolean") {
          this.booleanObject[key.type] = key.value;
          this.booleanObject = { ...this.booleanObject };
        } else if (typeof key.value == "object") {
          this.filesData[key.type] = key.value;
          this.filesData = { ...this.filesData };
          this.media_photos = this.filesData["media_photos"];
          this.media_videos = this.filesData["media_videos"];
        }
      }
    }
  },

  watch: {
    $route: {
      handler(route) {
        new Promise(reslove => {
          this.form = {};
          this.filesData = {};
          this.component = route.name;
          reslove();
        }).then(() => {
          this.getPageSettings();
        });
      },
      immediate: true
    }
  }
};
</script>

<style>
</style>